// extracted by mini-css-extract-plugin
module.exports = {"container":"PointCodeBlock_container__wSwf0","codeBlock":"PointCodeBlock_codeBlock__De_9o","content":"PointCodeBlock_content__9J7fh"};